export const CREATE_NEW_FAQ = 'CREATE_NEW_FAQ'
export const EDIT_FAQ = 'EDIT_FAQ'
export const DELETE_FAQ = 'DELETE_FAQ'